const AGENT_PANEL_ROLES = ["agent", "admin", "backofficesupport", "supervisor"];

export const isZoomEmbeddedApp = () =>
  typeof window !== "undefined" &&
  window.navigator.userAgent.includes("ZoomApps");

export const getPostLoginPath = (userType) => {
  if (!userType) {
    return "/";
  }

  if (userType === "interpreter") {
    return "/interpreter";
  }

  if (userType === "customer") {
    return "/customer";
  }

  if (AGENT_PANEL_ROLES.includes(userType)) {
    if (
      (userType === "admin" || userType === "supervisor") &&
      !isZoomEmbeddedApp()
    ) {
      return "/admin";
    }

    return "/agent";
  }

  return "/";
};
